import {
  ActionOutboxEntityType,
  CatalogResults,
  EventWithData,
  Listing,
  PurchaseOrderTicketGroup,
  Sale,
} from 'src/WebApiController';

import { useCatalogDataContext } from '../CatalogDataContext';
import { useSearchDataContext } from './SearchDataContext';

type SearchDataContextWithFallback = {
  data?: CatalogResults;
  isItemsLoading: boolean;
  eventsTransformed?: EventWithData[];
  totalItemsCount?: number | null;
  updateItemInEvent: (
    item: Listing | Sale | PurchaseOrderTicketGroup,
    entityType: ActionOutboxEntityType,
    sectionalUpdate?: boolean
  ) => void;
  refetch: () => void;
};

/**
 * Use this hook to get the search data context with a fallback to the catalog data context.
 * This is useful when we want to get the search data source when intended (for example, search page)
 * and fallback to the catalog data context when not intended (outside of search page).
 */
export const useSearchDataContextWithCatalogFallback =
  (): SearchDataContextWithFallback => {
    const searchDataContext = useSearchDataContext();
    const catalogDataContext = useCatalogDataContext();

    if (searchDataContext.isEnabled) {
      return {
        data: searchDataContext.data,
        isItemsLoading: searchDataContext.isLoading,
        eventsTransformed: searchDataContext.eventsTransformed,
        totalItemsCount: searchDataContext.totalItemsCount,
        updateItemInEvent: searchDataContext.updateItemInEvent,
        refetch: searchDataContext.refetch,
      };
    }
    return {
      data: catalogDataContext.data,
      isItemsLoading: catalogDataContext.isItemsLoading,
      eventsTransformed: catalogDataContext.eventsTransformed,
      totalItemsCount: null,
      updateItemInEvent: catalogDataContext.updateItemInEvent,
      refetch: () => {},
    };
  };
